import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import CourseSummary from 'modules/react/signup/CourseSummary'
import SuccessSvg from 'modules/react/signup/SuccessSvg'
import ProgressBar from 'modules/react/signup/ProgressBar'
import ProgressBarStep from 'modules/react/signup/ProgressBarStep'

export default function SignupCompletedCompany () {

  const { selectedCourseDate } = useContext(SignupContext)

  return (
    <>
      <LeftContent>
        <ProgressBar>
          <ProgressBarStep text={'Oplysninger'} active={true}/>
          <ProgressBarStep text={'Deltagerinformation'} active={true} previous={true}/>
          <ProgressBarStep text={'Du er tilmeldt!'} active={true} current={true}/>
        </ProgressBar>

        <div className="title title--h3">Tak for din tilmelding!</div>
        <div className="wysiwyg">Vi har registeret din tilmelding, og du modtager din endelige bekræftelse på kurset inden for få minutter.
        </div>
        <div className="image-wrap image-wrap--center">
          {SuccessSvg()}
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType="Virksomhed" selectedCourseDate={selectedCourseDate}/>
      </RightContent>
    </>
  )
}